import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function LocationSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.2 });
  const { ref: contentRef, isVisible: contentVisible } = useScrollReveal({ threshold: 0.1 });

  const advantages = [
    { icon: 'ri-anchor-line', text: 'Denize 70 metre' },
    { icon: 'ri-map-pin-line', text: "Kız Kumu Plajı'na yürüme mesafesi" },
    { icon: 'ri-tree-line', text: 'Doğa içinde sakin atmosfer' },
    { icon: 'ri-road-map-line', text: "Şehrin kalabalığından uzak" },
    { icon: 'ri-emotion-happy-line', text: 'Huzurlu tatil ortamı' },
  ];

  return (
    <section id="konum" className="w-full py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-secondary-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Text Content */}
          <div ref={headerRef} className={`transition-all duration-700 ${headerVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'}`}>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
              Marmaris Orhaniye'nin
              <br />
              <span className="text-primary-500">En Güzel Noktalarından</span>
              <br />
              Birinde
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 md:mb-8 leading-relaxed">
              İlkim Butik Otel, Marmaris Orhaniye'de denize yalnızca 70 metre mesafede ve dünyaca ünlü Kız Kumu Plajı'na yürüme mesafesinde yer alır.
            </p>

            <div ref={contentRef} className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mb-6 md:mb-8">
              {advantages.map((a, i) => (
                <div
                  key={a.text}
                  className={`flex items-center gap-3 p-3 bg-background-50 rounded-xl border border-background-200/60 transition-all duration-500 ${contentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 shrink-0">
                    <i className={`${a.icon} text-base`} />
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{a.text}</span>
                </div>
              ))}
            </div>

            <a
              href="https://wa.me/905395851199?text=Merhaba%2C%20İlkim%20Butik%20Otel%20hakkında%20bilgi%20almak%20istiyorum.%20Fiyat%20ve%20müsaitlik%20bilgisi%20alabilir%20miyim%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-xl font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
            >
              <i className="ri-whatsapp-line" />
              Konum ve Rezervasyon Bilgisi Al
            </a>
          </div>

          {/* Map */}
          <div className={`rounded-3xl overflow-hidden border border-background-200/60 shadow-md h-72 md:h-96 lg:h-full min-h-[300px] transition-all duration-700 delay-200 ${headerVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-6'}`}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6377.8343!2d28.1167!3d36.7539!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDQ1JzE0LjAiTiAyOMKwMDcnMDAuMSJF!5e0!3m2!1str!2str!4v1699999999999!5m2!1str!2str"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '300px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="İlkim Butik Otel Konum"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}